export const AnantRightSvg = ({ className }) => {
    return (
        <svg width="94" height="83" viewBox="0 0 94 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M87.3156 36.5444C79.4356 38.6871 63.6541 39.7073 57.7015 18.6737C65.5659 16.4687 81.7376 17.0028 87.3156 36.5444Z" fill="#F7F7F7" />
            <path className={className} d="M43.6249 18.7008C41.2393 26.5106 33.6934 40.4087 12.7227 34.238C15.0474 26.4082 24.1164 13.0082 43.6249 18.7008Z" fill="#F7F7F7" />
            <path className={className} d="M50.8521 72.2822C41.9945 63.8238 28.4554 44.3491 50.8524 20.4063C59.7779 28.7965 71.6235 49.9766 50.8521 72.2822Z" fill="#F7F7F7" />
        </svg>
    )
}

export const EnjoyRightSvg = ({ className }) => {
    return (
        <svg width="81" height="50" viewBox="0 0 81 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M73.5796 40.7468C62.4554 41.0033 41.2464 37.19 40.2534 7.42019C51.3775 7.07626 72.594 13.073 73.5796 40.7468Z" fill="#F7F7F7" />
            <path className={className} d="M40.7446 7.41964C41.0011 18.5439 37.1879 39.7529 7.41802 40.7459C7.07409 29.6218 13.0708 8.40528 40.7446 7.41964Z" fill="#F7F7F7" />
            <circle className={className} cx="41.2132" cy="44.9532" r="3.93831" transform="rotate(-165 41.2132 44.9532)" fill="#F7F7F7" />
        </svg>
    )
}

export const GetShieldedRightSvg = ({ className }) => {
    return (
        <svg width="69" height="71" viewBox="0 0 69 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M5.19184 5.94824C12.9748 5.754 27.8133 8.6416 28.5081 31.1849C20.7253 31.4454 5.88142 26.9043 5.19184 5.94824Z" fill="#F7F7F7" />
            <path className={className} d="M25.3713 61.7542C25.1022 49.12 29.1035 25.0322 60.3416 23.9044C60.7025 36.5384 54.41 60.6348 25.3713 61.7542Z" fill="#F7F7F7" />
            <ellipse className={className} cx="43.2019" cy="6.09045" rx="3.45577" ry="3.75256" fill="#F7F7F7" />
        </svg>
    )
}

export const LeaveRightSvg = ({ className }) => {
    return (
        <svg width="75" height="56" viewBox="0 0 75 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M-0.000490232 11.6998C8.10271 3.22713 26.7597 -9.72338 49.6969 11.7C41.6591 20.2376 21.3684 31.5682 -0.000490232 11.6998Z" fill="#F7F7F7" />
            <path className={className} d="M53.2444 49.0159C47.8218 43.8377 39.5332 31.9153 53.2446 17.2576C58.7088 22.3941 65.9606 35.3604 53.2444 49.0159Z" fill="#F7F7F7" />
        </svg>
    )
}

export const TrueSecurityRightSvg = ({ className }) => {
    return (
        <svg width="72" height="56" viewBox="0 0 72 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M62.6327 -8.46379e-07C68.8711 5.95717 78.4065 19.6731 62.6325 36.5357C56.3463 30.6266 48.0036 15.7096 62.6327 -8.46379e-07Z" fill="#F7F7F7" />
            <circle className={className} cx="63.675" cy="46.4253" r="3.35486" transform="rotate(15 63.675 46.4253)" fill="#F7F7F7" />
            <path className={className} d="M55.6709 43.7751C43.8991 49.141 19.4864 54.7732 4.799 23.4108C16.5306 17.9515 41.9508 14.6495 55.6709 43.7751Z" fill="#F7F7F7" />
        </svg>
    )
}

export const YourSarthiRightSvg = ({ className }) => {
    return (
        <svg width="75" height="54" viewBox="0 0 75 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={className} d="M6.8698 7.27847C17.1698 7.0408 36.8071 10.5742 37.7266 38.1589C27.4268 38.4776 7.78241 32.921 6.8698 7.27847Z" fill="#F7F7F7" />
            <path className={className} d="M37.273 38.1593C37.0355 27.8515 40.5662 8.1993 68.1301 7.27918C68.4485 17.5868 62.8961 37.246 37.273 38.1593Z" fill="#F7F7F7" />
            <ellipse className={className} cx="37.344" cy="49.9374" rx="3.36743" ry="3.36998" fill="#F7F7F7" />
        </svg>
    )
}

export const IndicatorsSvg = ({ className, fill, key }) => {
    return (
        <svg key={key} className={className} width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.88596 0.5C6.86627 3.4563 11.4217 10.2629 3.88587 18.6312C0.882721 15.6987 -3.10292 8.29605 3.88596 0.5Z" fill={fill} />
        </svg>
    )
}

export const StarSvg = ({ className, fill, key }) => {
    return (
        <svg key={key} className={className} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.88655 0.731874L12.6015 6.21603L18.6705 7.09566C18.7476 7.10704 18.8199 7.13957 18.8793 7.18957C18.9387 7.23957 18.9829 7.30506 19.0069 7.37868C19.0309 7.45229 19.0337 7.5311 19.0151 7.60622C18.9964 7.68135 18.9571 7.74981 18.9014 7.80389L14.5106 12.0718L15.5473 18.0993C15.5606 18.1755 15.5523 18.2539 15.5231 18.3256C15.4939 18.3973 15.4451 18.4594 15.3821 18.505C15.3192 18.5505 15.2447 18.5776 15.1671 18.5832C15.0894 18.5888 15.0118 18.5727 14.9429 18.5367L9.51425 15.6914L4.08559 18.5375C4.01675 18.5736 3.9391 18.5899 3.86144 18.5844C3.78378 18.5788 3.70924 18.5518 3.64628 18.5063C3.58333 18.4608 3.53448 18.3986 3.5053 18.3269C3.47612 18.2552 3.46777 18.1768 3.48121 18.1006L4.51788 12.0718L0.125888 7.80389C0.0701996 7.74981 0.0308143 7.68135 0.0121673 7.60622C-0.00647957 7.5311 -0.00364739 7.45229 0.020345 7.37868C0.0443373 7.30506 0.0885369 7.23957 0.147966 7.18957C0.207395 7.13957 0.279693 7.10704 0.356719 7.09566L6.42575 6.21603L9.14194 0.731874C9.17581 0.662379 9.2287 0.603769 9.29455 0.56276C9.36039 0.52175 9.43653 0.5 9.51425 0.5C9.59196 0.5 9.6681 0.52175 9.73394 0.56276C9.79979 0.603769 9.85268 0.662379 9.88655 0.731874Z" fill={fill} />
        </svg>
    )
}

export const CheckSvg = ({ className, fill, key }) => {
    return (
        <svg key={key} className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 14.8235L12.7059 20L24 12" stroke={fill} stroke-width="4" />
        </svg>
    )
}